export default "__VITE_ASSET__BzJsYv7g__"